import { useState, useEffect } from 'react';

export interface Breakpoints {
  isMobile: boolean;      // <= 480px
  isTablet: boolean;      // 481px - 768px
  isDesktop: boolean;     // > 768px
  isSmallScreen: boolean; // <= 768px
  isLargeScreen: boolean; // > 768px
}

export const useResponsive = (): Breakpoints => {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
    height: typeof window !== 'undefined' ? window.innerHeight : 768,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Adicionar listener de resize
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const width = windowSize.width;

  return {
    isMobile: width <= 480,
    isTablet: width > 480 && width <= 768,
    isDesktop: width > 768,
    isSmallScreen: width <= 768,
    isLargeScreen: width > 768,
  };
};
